// Cómo se obtuvo la diferencia acopio de un periodo del cierre, con los mismos
// valores que PeriodoCierreMensualProduccion en el backend
export const TIPO_DIFERENCIA_AUTOMATICA = 1;
export const TIPO_DIFERENCIA_MANUAL = 2;
export const TIPO_SIN_ENVIOS = 3;

export const BADGE_POR_TIPO_DIFERENCIA = {
    [TIPO_DIFERENCIA_AUTOMATICA]: { text: "Automática", variant: "primary" },
    [TIPO_DIFERENCIA_MANUAL]: { text: "Manual", variant: "info" },
    [TIPO_SIN_ENVIOS]: { text: "Sin envíos", variant: "secondary" },
};

export const CAMPOS_DIFERENCIA_ACOPIO = [
    "diferencia_acopio_lab",
    "diferencia_acopio_liquidacion",
];

export const TEXTO_PERIODO_SIN_ENVIOS =
    "No se registraron envíos a producción de este producto padre en el periodo";
